import { render, staticRenderFns } from "./EstudianteScreenImportacion.vue?vue&type=template&id=64122b9b&scoped=true"
import script from "./EstudianteScreenImportacion.vue?vue&type=script&lang=js"
export * from "./EstudianteScreenImportacion.vue?vue&type=script&lang=js"
import style0 from "./EstudianteScreenImportacion.vue?vue&type=style&index=0&id=64122b9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64122b9b",
  null
  
)

export default component.exports